import styled from 'styled-components';
import { P, PProps } from 'ia-react-core';
import { FC } from 'react';

export const StyledSectionTitle = styled<FC<PProps>>(P)`
  font-weight: bold;
  margin-bottom: 5px;
  :last-child {
      margin-bottom: 8px;
  }
`;

export const StyledSection = styled.section`
  margin-top: 20px;
  :first-of-type {
    margin-top: 0;
  }
 `;
